import React from 'react'

export const locationsAffectedTooltip = `
  The Locations Affected column will display as TBD
  until the indexed rate has been determined.
  Locations will be assigned once the indexed
  rate is made available.
`
